import $axios from './axios'
import {
    bizURL,
    courseURL,
    examURL
} from './baseUrl'

function getToken() {
    var getTokenId = sessionStorage.getItem("token");
    return getTokenId;
}

const portData = {
    getUserInfo(params) { // 获取学员信息
        return $axios({
            url: `${bizURL}/registration/getRegistrationEmployeeList?tokenId=${getToken()}&entpId=${sessionStorage.getItem('entpId')}`,
            method: "get",
            params: params
        });
    },
    exportApply(params) { // 导出报名信息
        var url = `${bizURL}/registration/getRegistrationEmployeeList?tokenId=${getToken()}&entpId=${sessionStorage.getItem('entpId')}&export=1`;
        // for(var value in url) {
        //     console.log(value);
        // }
        // return
        for (var i = 0; i < params.length; i++) {
            var item = params[i];
            url += '&' + item.key + '=' + item.value;
        }
        window.location.href = url;
    },
    importRegister(params) { // 导入报名记录
        return $axios({
            url: `${bizURL}/registration/importRegister?tokenId=${getToken()}`,
            method: "post",
            headers: {
                'Content-type': 'multipart/form-data'
            },
            data: params
        });
    },
    getSaveCourse(params) { // 激活课程
        return $axios({
            url: `${courseURL}/course/saveEmpCourse?tokenId=${getToken()}&entpId=${sessionStorage.getItem('entpId')}`,
            method: "post",
            data: params
        });
    },
    getSpecial(params) { // 获取注册专业
        return $axios({
            url: `${bizURL}/post/getPostList?tokenId=${getToken()}&entpId=${sessionStorage.getItem('entpId')}`,
            method: "get",
            params: params
        });
    },
    getOrder(params) { // 获取课程列表
        return $axios({
            url: `${courseURL}/order/getBizOrderCourse?tokenId=${getToken()}&entpId=${sessionStorage.getItem('entpId')}`,
            method: "get",
            params: params
        });
    },
    getOrderNumList(params) { // 获取订单列表
        return $axios({
            url: `${courseURL}/order/getOrderNumList?tokenId=${getToken()}&entpId=${sessionStorage.getItem('entpId')}`,
            method: "get",
            params: params
        });
    },
    getTrain(params) { // 培训记录
        return $axios({
            url: `${courseURL}/trainingRecord/getEntpTrainingRecord?tokenId=${getToken()}&entpId=${sessionStorage.getItem('entpId')}`,
            method: "get",
            params: params
        });
    },
    exportTrain(params) { // 导出培训记录
        var url = `${courseURL}/trainingRecord/getEntpTrainingRecord?tokenId=${getToken()}&entpId=${sessionStorage.getItem('entpId')}&export=1`;
        for (var i = 0; i < params.length; i++) {
            var item = params[i];
            url += '&' + item.key + '=' + item.value
        }
        window.location.href = url;
    },
    getBatch(params) { // 报名批次
        return $axios({
            url: `${bizURL}/batch/getBatchEmployeeList?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    addBatch(params) { // 新增批次
        return $axios({
            url: `${bizURL}/batch/addBatchEmployee?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    batchDetail(params) { // 获取单个批次信息
        return $axios({
            url: `${bizURL}/batch/batchDetail?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    updateBatch(params) { // 修改批次
        return $axios({
            url: `${bizURL}/batch/updateBatchEmployee?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    deleteBatch(params) { // 删除批次
        return $axios({
            url: `${bizURL}/batch/deleteBatchEmployee?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    addRegister(params) { // 新增报名
        return $axios({
            url: `${bizURL}/registration/addRegistration?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    addRegistrationForEmp(params) { // 新增报名管理 
        return $axios({
            url: `${bizURL}/registration/addRegistrationForEmp?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },

    getRegistration(params) { // 获取单个报名信息
        return $axios({
            url: `${bizURL}/registration/registrationDetail?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    updateRegister(params) { // 修改报名信息
        return $axios({
            url: `${bizURL}/registration/updateRegistration?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    deleteRegister(params) { // 删除报名信息
        return $axios({
            url: `${bizURL}/registration/deleteRegistrationEmployee?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    // getPhoto(params) {  // 查看学习照片
    //     return $axios({
    //         url: `${courseURL}/course/getEmployeeStudyPhotoList?tokenId=${getToken()}`,
    //         method: "get",
    //         params: params
    //     });
    // },
    getEmployeeInformation(params) { // 获取账户信息
        return $axios({
            url: `${bizURL}/employee/getEmployeeInformation?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    employeeDetail(params) { // 根据用户id获取用户信息
        return $axios({
            url: `${bizURL}/employee/employeeDetail?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    getPhoto(params) { // 查看学习照片
        return $axios({
            url: `${courseURL}/empStudy/getEmployeeStudyList?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    setEmpStudyListInvalid(params) { // 审核未通过
        return $axios({
            url: `${courseURL}/empStudy/setEmpStudyListInvalid?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    updatePassword(params) { // 修改密码
        return $axios({
            url: `${bizURL}/employee/enterpriseEmployeeModifyPassword?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    logout(params) { // 注销
        return $axios({
            url: `${bizURL}/employee/enterpriseEmployeeLogOut`,
            method: "post",
            data: params
        });
    },
    exerciseList(params) { // 测试记录查询
        return $axios({
            url: `${examURL}/exercise/exerciseEnterpriseRecordList?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    approvalExerciseRecord(params) { // 测试审核
        return $axios({
            url: `${examURL}/exercise/uploadExerciseImg?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    trainingRecord(params) { // 审核列表
        return $axios({
            url: `${courseURL}/trainingRecord/getApprovalEntpTrainingRecord?tokenId=${getToken()}&entpId=${sessionStorage.getItem('entpId')}`,
            method: "get",
            params: params
        });
    },
    approvalTrainingRecords(params) { // 审核通过
        return $axios({
            url: `${courseURL}/course/approvalTrainingRecords?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    getExerciseRecordImg(params) { // 获取考试图片
        return $axios({
            url: `${examURL}/exercise/getExerciseRecordImg?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    getReportingEntpTrainingRecord(params) { // 上报列表
        return $axios({
            url: `${courseURL}/trainingRecord/getReportingEntpTrainingRecord?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    reportingTrainingRecords(params) { // 标记为上报
        return $axios({
            url: `${courseURL}/course/reportingTrainingRecords?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    updateEmpStudyTime(params) { // 修改完成时间
        return $axios({
            url: `${courseURL}/course/updateEmpStudyTime?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    getReportingBatchList(params) { // 上报批次列表
        return $axios({
            url: `${courseURL}/batch/getReportingBatchList?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    getReportingBatchListNotPage(params) { // 上报批次列表
        return $axios({
            url: `${courseURL}/batch/getReportingBatchListNotPage?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    addReportingBatch(params) { // 新增上报批次
        return $axios({
            url: `${courseURL}/batch/addReportingBatch?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    updateReportingBatch(params) { // 修改上报批次
        return $axios({
            url: `${courseURL}/batch/updateReportingBatch?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    deleteReportingBatch(params) { // 删除上报批次
        return $axios({
            url: `${courseURL}/batch/deleteReportingBatch?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    setReportingBatch(params) { // 标记上报批次
        return $axios({
            url: `${courseURL}/batch/setReportingBatch?tokenId=${getToken()}`,
            method: "post",
            data: params
        });
    },
    autoUpdateEmpStudyTime(params) { // 一键修改学习时间
        return $axios({
            url: `${courseURL}/trainingRecord/autoUpdateEmpStudyTime?tokenId=${getToken()}`,
            method: "post",
            params: params
        });
    },
    updateApprovalTime(params) { // 修改审核时间
        return $axios({
            url: `${courseURL}/trainingRecord/updateApprovalTime?tokenId=${getToken()}`,
            method: "post",
            params: params
        });
    },
    selectAnnualType(params) { // 继续教育年度列表
        return $axios({
            url: `${courseURL}/trainingRecord/selectAnnualType?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },


    updateAnnualFlag(params) { // 取消确定标记
        return $axios({
            url: `${bizURL}/registration/updateAnnualFlag?tokenId=${getToken()}`,
            method: "post",
            params: params
        });
    },

    getUserSaveStudyPhoto(params) { // 照片管理
        return $axios({
            url: `${courseURL}/videoPlay/getUserSaveStudyPhoto?tokenId=${getToken()}`,
            method: "get",
            params: params
        });
    },
    delPhoto(params) { // 删除照片
        return $axios({
            url: `${courseURL}/videoPlay/delPhoto?tokenId=${getToken()}`,
            method: "post",
            params: params
        });
    },
    userSaveStudyPhoto(params) { // 保存单个上传照片
        return $axios({
            url: `${courseURL}/videoPlay/userSaveStudyPhoto?tokenId=${getToken()}`,
            method: "post",
            params: params
        });
    },

    uploadZip(params) {  // 批量上传图片
        return $axios({
            url: `${courseURL}/videoPlay/uploadZip?tokenId=${getToken()}`,
            method: "post",
            params: params
        });
    },

    updateSuspensionType(params) {  // 停学、取消停学的接口
        return $axios({
            url: `${bizURL}/registration/updateSuspensionType?tokenId=${getToken()}`,
            method: "post",
            params: params
        });
    },
    registrationEmployeeModifyPassword(params) {  // 批量重置密码
        return $axios({
            url: `${bizURL}/employee/registrationEmployeeModifyPassword?tokenId=${getToken()}`,
            method: "post",
            params: params
        });
    },
}

export default portData;